import TYPES from "@modals/TYPES";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    types: [],
    data: {}
};

const modalsSlice = createSlice({
    name: 'modals',
    initialState,
    reducers: {
        openModal: (state, action) => { 
            console.log(action)
            state.types = [...state.types, action.payload.type]; 
            state.data = {
                ...state.data,
                [action.payload.type]: action.payload.data
            }; 
        },
        closeModal: (state, action) => { 
            state.types = state.types.filter((type) => action.payload.type !== type); 
            // Удаляем данные модалки по ключу
            const newData = {...state.data};
            delete newData[action.payload.type];
            state.data = newData;
        },
        closeAllModal: (state) => { 
            state.types = initialState.types;
            state.data = initialState.data;
        },
    },
    // extraReducers: (builder) => {
    //     builder.addMatcher(
    //     (action) => {
    //         return action.type === 'timetable/addAction'
    //     },
    //     (state, action) => {
    //         console.log('Current state:', {
    //             types: [...state.types],
    //             data: {...state.data}
    //         });
    //         console.log(action)
    //     //    openModal()
    //     }
    //     );
    // }
});

const { actions, reducer } = modalsSlice;

export default reducer;

export const {
    openModal,
    closeModal,
    closeAllModal
} = actions;

export const closeModalSelectFiles = () => closeModal({type: TYPES.SELECT_FILES_FROM_MEDIA_PLATFORM});
